import { render, staticRenderFns } from "./HelpPopover.vue?vue&type=template&id=8dcb0740&scoped=true&"
import script from "./HelpPopover.vue?vue&type=script&lang=js&"
export * from "./HelpPopover.vue?vue&type=script&lang=js&"
import style0 from "./HelpPopover.vue?vue&type=style&index=0&id=8dcb0740&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dcb0740",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("Q:\\Projects\\marketingdatabase-git\\MarketingDb.Web.Zeiss\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8dcb0740')) {
      api.createRecord('8dcb0740', component.options)
    } else {
      api.reload('8dcb0740', component.options)
    }
    module.hot.accept("./HelpPopover.vue?vue&type=template&id=8dcb0740&scoped=true&", function () {
      api.rerender('8dcb0740', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/JourneyBuilder/Components/Elements/HelpPopover.vue"
export default component.exports